import { Container, Text } from 'pixi.js';
import type { MenuPage } from './MainMenuView';

export class DummyPageView extends Container implements MenuPage {
  private readonly dummyText: Text;

  constructor(label = 'Dummy Page') {
    super();

    this.dummyText = new Text({
      text: label,
      style: {
        fontSize: 60,
        fill: 'black',
      },
    }).props({
      parent: this,
      anchor: 0.5,
    });
  }

  public isAboveTopBar(): boolean {
    return false;
  }

  public show(): void {}

  public hide(): void {}

  public resize(_width: number, height: number): void {
    this.dummyText.y = height * 0.5;
  }
}
